import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'grid',
      gridTemplateColumns: 'auto auto',
      gridTemplateRows: 'auto auto 1fr',
      gridTemplateAreas: `
      'title title'
      'count quantiles'
      'summary quantiles'
      `,
      alignItems: 'start',
      gridColumnGap: theme.spacing(1.5),
      gridRowGap: theme.spacing(1),
      padding: theme.spacing(1),
    },
    title: {
      gridArea: 'title',
      display: 'flex',
      alignItems: 'center',
    },
    subtitle: {
      fontStyle: 'italic',
      marginBottom: theme.spacing(0.5),
    },
    count: {
      gridArea: 'count',
      fontSize: '0.8em',
    },
    summary: {
      gridArea: 'summary',
      fontSize: '0.8em',
    },
    quantiles: {
      gridArea: 'quantiles',
      fontSize: '0.8em',
    },
    setColor: {
      fontSize: 'inherit',
      marginRight: theme.spacing(0.5),
    },
    valueTable: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      gridColumnGap: theme.spacing(1),
      gridRowGap: theme.spacing(1),
    },
    label: {},
    valueCell: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
  };
};
